(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-slider"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  const swiperWhyChooseIceGames = new Swiper(`.card-slider .why-choose-ice-games-container`, {
  slidesPerView: "auto",
  pagination: {
    el: `.card-slider .swiper-pagination`,
    clickable: true,
  },
  loop: false,
});
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-hp"] && !Shopify.designMode) return;
  try {
    
  const elementsSelectors = [
    '.featured-collection_product-title',
    '.featured-collection_product-sub-title',
    '.custom-price-atc-wrapper'
  ];
  // Run the equalization after images have loaded
  window.addEventListener('load', function() {
    equalizeElementHeights('.featured-collection_wrapper');
  });

  function equalizeElementHeights(swiperContainerSelector) {
    // get the elements - title and subtitle
    const titles = document.querySelectorAll(`${swiperContainerSelector} .featured-collection_product-title`);
    const subTitles = document.querySelectorAll(`${swiperContainerSelector} .featured-collection_product-sub-title`);
    const customPriceAtcWrappers = document.querySelectorAll(`${swiperContainerSelector} .custom-price-atc-wrapper`);
    
    // get the max height for each respective element
    const titleMaxHeight = Math.max(...Array.from(titles).map(title => title.offsetHeight));
    const subTitleMaxHeight = Math.max(...Array.from(subTitles).map(subTitle => subTitle.offsetHeight));
    const customPriceAtcWrapperMaxHeight = Math.max(...Array.from(customPriceAtcWrappers).map(customPriceAtcWrapper => customPriceAtcWrapper.offsetHeight));
    // set the max height for each respective element
    
    // Object to store the maximum heights for each selector
    let maxTitleHeight = 0;
    let maxSubtitleHeight = 0;

    document.querySelectorAll(`${swiperContainerSelector} .swiper-slide:not(.swiper-slide-duplicate)`).forEach(slide => {
      const titleElements = slide.querySelectorAll('.featured-collection_product-title');
      const subtitleElements = slide.querySelectorAll('.featured-collection_product-sub-title');

      titleElements.forEach(el => {
        maxTitleHeight = Math.max(maxTitleHeight, el.offsetHeight);
      });
      subtitleElements.forEach(el => {
        maxSubtitleHeight = Math.max(maxSubtitleHeight, el.offsetHeight);
      });
    });

    // Apply the maximum height to all titles and subtitles
    document.querySelectorAll(swiperContainerSelector).forEach(container => {
      container.querySelectorAll('.featured-collection_product-title').forEach(el => {
        el.style.height = `${maxTitleHeight}px`;
      });
      container.querySelectorAll('.featured-collection_product-sub-title').forEach(el => {
        el.style.height = `${maxSubtitleHeight}px`;
      });
    });
  }


  const swiperFeatured = new Swiper('.featured-collection_wrapper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      360: {
        loop: true,
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
        loop: true,
      },
      990: {
        slidesPerView: 3,
        loop: true,
      },
      1024: {
        slidesPerView: 4,
        loop: true,
      },
    },
    on: {
      init: function () {
        equalizeElementHeights('.featured-collection_wrapper')
      },
      slideChangeTransitionEnd: function () {
        equalizeElementHeights('.featured-collection_wrapper')
      },
      click: function () {
        // console.log('click');
        equalizeElementHeights('.featured-collection_wrapper');
      },
      activeIndexChange: function () {
        // console.log('slideChange');
        equalizeElementHeights('.featured-collection_wrapper');
        // setTimeout(() => {
        //   equalizeElementHeights('.featured-collection_wrapper');
        // }, 100); // Adjust delay as needed
      },
    },

  });

  // Equalize heights on window resize
  window.addEventListener('resize', function () {
    equalizeElementHeights('.featured-collection_wrapper')
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-hp"] && !Shopify.designMode) return;
  try {
    

const swiperFeatruedProduct = new Swiper(".featrued-product-hp_container", {
      slidesPerView: 1,
  loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !Shopify.designMode) return;
  try {
    
  const elementsSelectors = [
    '.featured-product_title',
    '.featured-product_sub-title',
    '.custom-price-atc-wrapper'
  ];

  window.addEventListener('load', function() {
    equalizeElementHeights('.featured-products_wrapper');
  });

  function equalizeElementHeights(swiperContainerSelector) {
    const titles = document.querySelectorAll(`${swiperContainerSelector} .featured-product_title`);
    const subTitles = document.querySelectorAll(`${swiperContainerSelector} .featured-product_sub-title`);
    const customPriceAtcWrappers = document.querySelectorAll(`${swiperContainerSelector} .custom-price-atc-wrapper`);
    
    const titleMaxHeight = Math.max(...Array.from(titles).map(title => title.offsetHeight));
    const subTitleMaxHeight = Math.max(...Array.from(subTitles).map(subTitle => subTitle.offsetHeight));
    const customPriceAtcWrapperMaxHeight = Math.max(...Array.from(customPriceAtcWrappers).map(customPriceAtcWrapper => customPriceAtcWrapper.offsetHeight));

    let maxTitleHeight = 0;
    let maxSubtitleHeight = 0;

    document.querySelectorAll(`${swiperContainerSelector} .swiper-slide:not(.swiper-slide-duplicate)`).forEach(slide => {
      const titleElements = slide.querySelectorAll('.featured-product_title');
      const subtitleElements = slide.querySelectorAll('.featured-product_sub-title');

      titleElements.forEach(el => {
        maxTitleHeight = Math.max(maxTitleHeight, el.offsetHeight);
      });
      subtitleElements.forEach(el => {
        maxSubtitleHeight = Math.max(maxSubtitleHeight, el.offsetHeight);
      });
    });

    document.querySelectorAll(swiperContainerSelector).forEach(container => {
      container.querySelectorAll('.featured-product_title').forEach(el => {
        el.style.height = `${maxTitleHeight}px`;
      });
      container.querySelectorAll('.featured-product_sub-title').forEach(el => {
        el.style.height = `${maxSubtitleHeight}px`;
      });
    });
  }

  const swiperFeatured = new Swiper('.featured-products_wrapper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      360: {
        loop: true,
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 2,
        loop: true,
      },
      990: {
        slidesPerView: 3,
        loop: true,
      },
      1024: {
        slidesPerView: 4,
        loop: true,
      },
    },
    on: {
      init: function () {
        equalizeElementHeights('.featured-products_wrapper')
      },
      slideChangeTransitionEnd: function () {
        equalizeElementHeights('.featured-products_wrapper')
      },
      click: function () {
        equalizeElementHeights('.featured-products_wrapper');
      },
      activeIndexChange: function () {
        equalizeElementHeights('.featured-products_wrapper');
      },
    },

  });

  window.addEventListener('resize', function () {
    equalizeElementHeights('.featured-products_wrapper')
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const submitButton = document.querySelector('.klaviyo_submit_button');
  const emailInput = document.querySelector('#k_id_email');

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  submitButton.addEventListener('click', function (e) {
    if (validateEmail(emailInput.value)) {
      emailInput.classList.remove('error-border');
    } else {
      emailInput.classList.add('error-border');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const body = document.querySelector('body');
  const header = document.querySelector('header.header');
  header.classList.contains('sticky') ? body.classList.add('sticky') : false;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-by-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.list-by-league .tab').forEach(tab => {
        tab.addEventListener('click', () => {
            const sectionId = tab.closest('section').id;
            const container = document.querySelector(`#${sectionId}`);
            const tabs = container.querySelectorAll('.tab-container .tab');
            const contents = container.querySelectorAll('.tab-content');

            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));

            tab.classList.add('active');
            if (!!container.querySelector(`.tab-content-${tab.dataset.tab}`)) {
                container.querySelector(`.tab-content-${tab.dataset.tab}`).classList.add('active');
            }
        });
    });

    

    document.querySelectorAll('.show-more').forEach(button => {
        button.addEventListener('click', () => {
            const tab = button.dataset.tab;
            const collectionHandle = button.dataset.handle;
            const items = document.querySelectorAll(`.tab-content-${tab} .item.hidden`);
            items.forEach(item => item.classList.remove('hidden'));
            button.style.display = 'none';
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-by-league"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.list-by-leauge .tab').forEach(tab => {
        tab.addEventListener('click', () => {
            const sectionId = tab.closest('section').id;
            const container = document.querySelector(`#${sectionId}`);
            const tabs = container.querySelectorAll('.tab-container .tab');
            const contents = container.querySelectorAll('.tab-content');

            tabs.forEach(t => t.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));

            tab.classList.add('active');
            if (!!container.querySelector(`.tab-content-${tab.dataset.tab}`)) {
                container.querySelector(`.tab-content-${tab.dataset.tab}`).classList.add('active');
            }
        });
    });

    document.querySelectorAll('.show-more').forEach(button => {
        button.addEventListener('click', () => {
            const tab = button.dataset.tab;
            const items = document.querySelectorAll(`.tab-content-${tab} .item.hidden`);
            items.forEach(item => item.classList.remove('hidden'));
            button.style.display = 'none';
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-header"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.collection-header_carousel-container', {
    slidesPerView: 7,
    slidesPerGroup: 7,
    loop: true,
    navigation: {
      nextEl: '.header-slides_prev',
      prevEl: '.header-slides_next',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      600: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      900: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      1024: {
        slidesPerView: 6,
        slidesPerGroup: 6,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-support"] && !Shopify.designMode) return;
  try {
    
    const questions = document.querySelectorAll(".q");

    questions.forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle("active");
            this.nextElementSibling.classList.toggle("open");
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider-2"] && !Shopify.designMode) return;
  try {
    

const swiperWhyChooseIceGames = new Swiper(`.why-choose-ice-games-container`, {
  slidesPerView: 3,
  slidesPerGroup: 3,
  loop: false,
  centerInsufficientSlides: true,
  pagination: {
    el: `.swiper-pagination`,
    clickable: true,
  },
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const swiperInstances = {};

    document.querySelectorAll('.tab').forEach((tab, index) => {
        const sectionId = tab.closest('section').id;
        tab.addEventListener('click', () => {
            const container = document.querySelector(`#${sectionId}`);
            const tabs = container.querySelectorAll('.tab-container .tab');
            const swipers = container.querySelectorAll('.swiper-container');

            tabs.forEach(t => t.classList.remove('active'));
            swipers.forEach(content => content.classList.remove('active'));

            tab.classList.add('active');
            if (container.querySelector(`.swiper-container-${tab.dataset.tab}`)) {
                container.querySelector(`.swiper-container-${tab.dataset.tab}`).classList.add('active');
                updateSwipers(sectionId, tab.dataset.tab);
            }
        });

        if (index === 0) {
            tab.classList.add('active');
            const container = document.querySelector(`#${sectionId}`);
            const initialSwiper = container.querySelector(`.swiper-container-${tab.dataset.tab}`);
            if (initialSwiper) {
                initialSwiper.classList.add('active');
                updateSwipers(sectionId, tab.dataset.tab);
            }
        }
    });

    function updateSwipers(sectionId, tabId) {
        if (swiperInstances[sectionId]) {
            swiperInstances[sectionId].forEach(swiper => swiper.destroy(true, true));
        } else {
            swiperInstances[sectionId] = [];
        }

        const container = document.querySelector(`#${sectionId}`);
        container.querySelectorAll(`.swiper-container-${tabId}`).forEach(content => {
            const swiperConfig = {
                slidesPerView: 3,
                slidesPerGroup: 3,
                loop: false,
                centerInsufficientSlides: true,
                pagination: {
                    el: `#${sectionId} .swiper-pagination-${content.classList[1].split('-')[2]}`,
                    clickable: true,
                },
            };
            const swiper = new Swiper(content, swiperConfig);
            swiperInstances[sectionId].push(swiper);
        });
    }

    document.querySelectorAll('section').forEach(section => {
        const firstTab = section.querySelector('.tab.active');
        if (firstTab) {
            updateSwipers(section.id, firstTab.dataset.tab);
        } else {
            // Handle case where there is only one tab
            const onlySwiper = section.querySelector('.swiper-container');
            if (onlySwiper) {
                onlySwiper.classList.add('active');
                updateSwipers(section.id, onlySwiper.classList[1].split('-')[2]);
            }
        }
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    

    const swiper = new Swiper(".review-carousel_swiper", {
          slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            360: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            }
        }
    });
    
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scp_info"] && !Shopify.designMode) return;
  try {
    
  const swiperSCP = new Swiper('.scp-carousel', {
    slidesPerView: 1,
    spaceBetween: 10,
    breakpoints: {
      640: {
        spaceBetween: 32,
        slidesPerView: 2,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-chexx-pro-features"] && !Shopify.designMode) return;
  try {
    
    const lifestyleCarousel = new Swiper(".lifestyle-carousel", {
          slidesPerView: 1,
          pagination: {
            el: ".lifestyle-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: '.right-arrow',
            prevEl: '.left-arrow',
          }
    });

document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('.play-button').addEventListener('click', function (e) {
        //get video id for play/pause
        const button = e.target.closest(".play-button");
        const id = button.getAttribute("data-video-id");
        if (button.style.opacity == '1' || button.style.opacity == '') {
            document.querySelector('#' + id).play();
            button.style.opacity = 0;
        } else {
            document.querySelector('#' + id).pause();
            button.style.opacity = 1;
        }
    });
});


  } catch(e) { console.error(e); }
})();
})();
